<template>
    <div class="toolbox-wrapper">
        <div class="toolbox">
            <slot/>
        </div>
        <div class="help-line">
            {{currentHelp}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "Toolbox",
        data: function () {
            return {
                currentHelp : ""
            }
        },
        provide: function() {
            return {
                showHelp: this.renderHelpText,
                clearHelp: () => this.renderHelpText("")
            }
        },
        methods: {
            renderHelpText(text) {
                this.currentHelp = text;
            }
        }
    }
</script>

<style lang="scss" scoped>
.toolbox-wrapper {
    position: relative;
    width: calc(100% + 40px);
    left: -20px;
    margin: 10px 0px 10px 0px;
}

.toolbox {
    background-color: var(--card-light-background-color);
    display: grid;
    grid-template: 1fr /  repeat(auto-fill, 30px);
    grid-gap: 10px;
    height: 50px;
    padding: 5px 5px 5px 5px;
}

.help-line {
    padding: 5px 20px 5px 20px;
    background-color: lighten(#262C32, 20);
    min-height: 25px;
    font-size: 12px;
}
</style>